export const setOrmWidgetData = (value, index, data) => {
	let updateData = [...data];
	updateData[index].graphData = value;
	return { type: "SET_ORM_WIDGET_DATA", payload: updateData };
};
export const ResetOrmWidgetData = (value) => {
	return { type: "RESET_ORM_WIDGET", payload: value };
};
export const setTicketOffset = (value) => {
	return { type: "SET_TICKET_OFFSET", payload: value };
};
export const setOrmDate = (value) => {
	return { type: "SET_ORM_DATE", payload: value };
};
export const setOrmBrands = (value) => {
	return { type: "SET_ORM_BRANDS", payload: value };
};
